export default "__VITE_ASSET__DqDYULmW__"